import {SubscriptionBuyingOpaque} from "./subscriptionBuyingOpaque";
import {AdditionalSubscriptionBuyingOpaque} from "./additionalSubscriptionBuyingOpaque";
import {AdditionalSubscriptionAddingOpaque} from "./additionalSubscriptionAddingOpaque";

export class TransactionOpaque {
  subscriptionBuyingOpaque: SubscriptionBuyingOpaque | null;
  additionalSubscriptionBuyingOpaque: AdditionalSubscriptionBuyingOpaque | null;
  additionalSubscriptionAddingOpaque: AdditionalSubscriptionAddingOpaque | null;

  constructor(
    subscriptionBuyingOpaque: SubscriptionBuyingOpaque | null,
    additionalSubscriptionBuyingOpaque: AdditionalSubscriptionBuyingOpaque | null,
    additionalSubscriptionAddingOpaque: AdditionalSubscriptionAddingOpaque | null,
  ) {
    this.subscriptionBuyingOpaque = subscriptionBuyingOpaque;
    this.additionalSubscriptionBuyingOpaque = additionalSubscriptionBuyingOpaque;
    this.additionalSubscriptionAddingOpaque = additionalSubscriptionAddingOpaque;
  }

  public static withSubscriptionBuyingOpaque(subscriptionBuyingOpaque: SubscriptionBuyingOpaque) {
    return new TransactionOpaque(subscriptionBuyingOpaque, null, null)
  }

  public static withAdditionalSubscriptionBuyingOpaque(additionalSubscriptionBuyingOpaque: AdditionalSubscriptionBuyingOpaque) {
    return new TransactionOpaque(null, additionalSubscriptionBuyingOpaque, null)
  }

  public static withAdditionalSubscriptionAddingOpaque(additionalSubscriptionAddingOpaque: AdditionalSubscriptionAddingOpaque) {
    return new TransactionOpaque(null, null, additionalSubscriptionAddingOpaque)
  }

  public static noArgs() {
    return new TransactionOpaque(null, null, null);
  }

  public static isNoArgs(opaque: TransactionOpaque) {
    const hasntAddingOpaque = opaque.additionalSubscriptionAddingOpaque == null;
    const hasntBuyingOpaque = opaque.subscriptionBuyingOpaque == null;
    const hasntAdditionalBuyingOpaque = opaque.additionalSubscriptionBuyingOpaque == null;
    return hasntAddingOpaque && hasntBuyingOpaque && hasntAdditionalBuyingOpaque;
  }
}
